import { getOrder, updateOrder } from "../../order/index.js";
import { getCustomPaymentFromOrder, } from "../index.js";
export const setOrderPaymentProperties = async ({ orderId, properties }, { client }) => {
    const order = await getOrder({ orderId }, { client });
    const payment = getCustomPaymentFromOrder(order);
    if (!payment)
        throw new Error(`Payment provider not found for orderId: ${orderId}`);
    return await updateOrder({
        id: orderId,
        payment: [
            {
                provider: "custom",
                custom: {
                    properties: payment.properties
                        ? [...payment.properties, ...properties]
                        : properties,
                },
            },
        ],
    }, {
        client,
    });
};
